import { PREVIEW_TYPES } from '@wix/wix-vod-constants/common';
export const getTrailerTypeString = videoItem => {
  if (!videoItem) {
    return 'none';
  }
  let {
    trailerType
  } = videoItem;
  trailerType = trailerType || PREVIEW_TYPES.FIRST_20_SEC;
  switch (trailerType) {
    case PREVIEW_TYPES.FIRST_20_SEC:
      return 'preview';
    case PREVIEW_TYPES.TRAILER:
      return 'trailer';
    case PREVIEW_TYPES.NONE:
    default:
      return 'none';
  }
};
//# sourceMappingURL=get-trailer-type-string.js.map